export { default, getStaticProps } from '../src/pages/Home'
